import React from 'react';
import PropTypes from 'prop-types';
import Title from 'src/components/AccountSettings/Title';
import NoConnections from './no-connections';
import ConnectionsList from './connections-list';
import RejectedConnectionsList from './rejected-connections-list';

class Connections extends React.Component {
  static propTypes = {
    acceptConnection: PropTypes.func.isRequired,
    acceptEducatorConnection: PropTypes.func.isRequired,
    educatorConnections: PropTypes.arrayOf(PropTypes.object),
    userConnections: PropTypes.arrayOf(PropTypes.object),
    fetchUserConnections: PropTypes.func.isRequired,
    getEducatorConnections: PropTypes.func.isRequired,
    destroyConnection: PropTypes.func.isRequired,
    rejectConnection: PropTypes.func.isRequired,
    rejectEducatorConnection: PropTypes.func.isRequired,
    setNavigationAnnouncement: PropTypes.func,
    description: PropTypes.string,
  };

  componentDidMount() {
    const {setNavigationAnnouncement, getEducatorConnections, fetchUserConnections} = this.props;

    if (setNavigationAnnouncement) {
      setNavigationAnnouncement('Connections');
    }

    getEducatorConnections();
    fetchUserConnections();
  }

  render() {
    const {
      educatorConnections,
      userConnections,
      acceptEducatorConnection,
      rejectEducatorConnection,
      acceptConnection,
      destroyConnection,
      rejectConnection,
      description,
    } = this.props;

    const connectionsCount = educatorConnections.length + userConnections.length;

    return (
      <>
        <div className="account-settings-form" id="connections-container">
          <Title>Connections</Title>
          <p className="shared-text shared-text-show-overflow high-school-student-connections-page-text">
            {description}
          </p>

          {connectionsCount ? (
            <ConnectionsList
              educatorConnections={educatorConnections}
              userConnections={userConnections}
              acceptEducatorConnection={acceptEducatorConnection}
              rejectEducatorConnection={rejectEducatorConnection}
              acceptConnection={acceptConnection}
              rejectConnection={rejectConnection}
              removeConnection={destroyConnection}
            />
          ) : (
            <NoConnections />
          )}
        </div>
        <RejectedConnectionsList
          educatorConnections={educatorConnections}
          userConnections={userConnections}
          acceptEducatorConnection={acceptEducatorConnection}
          rejectEducatorConnection={rejectEducatorConnection}
          acceptConnection={acceptConnection}
          rejectConnection={rejectConnection}
          removeConnection={destroyConnection}
        />
      </>
    );
  }
}

export default Connections;
